import React, { useEffect } from "react";
import "./MettressCustomizations.scss";
import { useDispatch, useSelector } from "react-redux";
import DropDown from "../DropDown/DropDown";
import {
  setMettressDepth,
  setMettressSize,
} from "../../Redux/MettressCustomizations/MettressCustomizations.actions";
import { depths } from "../../Config/constant";

const MettressCustomizations = (props) => {
  const dispatch = useDispatch();
  const size = useSelector((state) => state.mettressCustomizations.size);
  const depth = useSelector((state) => state.mettressCustomizations.depth);
  const data = useSelector((state) => state.products.activeProduct);

  const handleSizeChange = (value) => {
    const fullSize = data.others.sizes.filter(
      (size) => size.value === value
    )[0];
    dispatch(setMettressSize(fullSize));
  };

  const handleDepthChange = (value) => {
    const fullDepth = depths.filter((depth) => depth.value === value)[0];
    dispatch(setMettressDepth(fullDepth));
  };

  return (
    <div className="MettressCustomizations">
      <h2>Customizations</h2>

      <DropDown
        data={data.others.sizes}
        value={size.value}
        onChange={(e) => handleSizeChange(e.target.value)}
        text="Size"
      />
      {data.others.thickness && (
        <DropDown
          data={depths}
          value={depth.value}
          onChange={(e) => handleDepthChange(e.target.value)}
          text="Depth"
        />
      )}
    </div>
  );
};

export default MettressCustomizations;
